<template>
  <div class="container full-height">
    <div class="row">
      <div class="col-12">
        <div class="title">{{ labelBox.title }}</div>
        <div v-show="labelBox.subtitle" class="subtitle">
          {{ labelBox.subtitle }}:
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div style="text-align: right;">
          <q-select
            :data-cy="labelDataCy"
            multiple
            outlined
            use-input
            hide-selected
            v-model="arraySelectedOptions"
            :error="isMandatory"
            :options="arrayOptions"
            @filter="filterFn"
            option-value="id"
            option-label="name"
            :label="labelBox.select"
            :disable="isDisabled">
            <template v-slot:error>
              <span>Dato obligatorio.</span>
            </template>
            <template
              v-slot:option="{
              itemProps,
              itemEvents,
              opt,
              selected,
              toggleOption,
            }">
              <q-item v-bind="itemProps" v-on="itemEvents" active-class="multiple-select-active">
                <q-item-section :side="true">
                  <q-checkbox :value="selected" @input="toggleOption(opt)" />
                </q-item-section>
                <q-item-section no-wrap class="ellipsis multiple-select" style="width: 100px">
                  <q-item-label>{{ opt.name }} </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div style="overflow-y: auto">
        <div v-for="item in arraySelectedOptions" :key="item.id" style="display: inline-block; margin-bottom: 11px">
          <q-chip removable @remove="removeElement(item)" text-color="black" outline class="a" :disable="isDisabled">
            {{ item.name }}
          </q-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Utils from '@/components/shared/helpers/Utils.js';
import { useVuelidate } from '@vuelidate/core';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {},
  mixins: [Message, Validation],
  props: {
    labelDataCy: String,
    labelBox: {
      type: Object,
      required: false,
      default: () => ({
        title: 'Opciones que la utilizan',
        subtitle: null,
        select: 'Añadir opción'
      })
    },
    isMandatory: { type: Boolean, required: false },
    arraySelected: { type: Array, required: true },
    arrayAll: { type: Array, required: true },
    endPoint: { type: String, required: true },
    dataObj: { type: Object, required: true },
    relationShip: { type: String, required: true },
    eventSave: { type: String, required: true },
    eventCheck: { type: String, required: false },
    isDisabled: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      arraySelectedOptions: this.arraySelected,
      arrayOptions: this.arrayAll
    };
  },
  mounted () {
    this.$eventHub.$on(this.eventCheck, ({ callback }) => {
      let responseData = {
        data: null,
        status: true
      };
      if (this.arraySelectedOptions.length <= 0) {
        this.v$.arraySelectedOptions.$touch();
        responseData = {
          data: null,
          status: false
        };
      }
      callback(responseData);
    });

    this.$eventHub.$on(this.eventSave, async (id, { callback }) => {
      await this.setOptions(callback, id);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off(this.eventSave);
    this.$eventHub.$off(this.eventCheck);
  },
  methods: {
    filterFn (val, update) {
      update(() => {
        this.arrayOptions = Utils.filterFnWithoutAccents(val, this.arrayAll);
      });
    },
    removeElement (element) {
      var idx = this.arraySelectedOptions.indexOf(element);
      this.arraySelectedOptions.splice(idx, 1);
      if (this.arraySelectedOptions.length <= 0) {
        this.v$.arraySelectedOptions.$touch();
      }
    },
    async setOptions (callback, id) {
      let options = this.arraySelectedOptions.map((n) => n.id);
      let dataArray = options;

      let request = {
        controller: `/${this.endPoint}/${id.id}/${this.relationShip}`,
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };

          callback(responseData);
        })
        .catch((err) => {
          responseData = {
            data: null,
            status: false
          };

          callback(responseData);
          this.showError(err.message);
        });
    },
    _setSelectedOptions (options) {
      let data = [];
      this.arrayOptions.forEach(elem => {
        options.forEach(i => {
          if (elem.id === i) {
            data.push(elem);
          }
        });
      });

      return data;
    }
  },
  watch: {
    arraySelected: {
      handler: function () {
        this.arraySelectedOptions = this.arraySelected;
        if (Object.entries(this.arrayOptions).length > 0) {
          this.arraySelectedOptions = this._setSelectedOptions(this.arraySelectedOptions);
        }
      },
      immediate: true
    },
    arrayAll: {
      handler: function () {
        this.arrayOptions = this.arrayAll;
        if (Object.entries(this.arrayOptions).length > 0) {
          this.arraySelectedOptions = this._setSelectedOptions(this.arraySelectedOptions);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .q-chip--outline {
    border: solid 1px #415d9a !important;
  }

  &:deep() {
    .q-chip__content {
      font-size: 10px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #003f87;
    }
  }
}
</style>
